import { Component } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-form-flex-col',
  imports: [FormlyModule],
  template: `
    <div data-debug="flex-layout-col" class="content formly-form-flex">
      @for (f of field.fieldGroup; track f) {
        <formly-field [field]="f"></formly-field>
      }
    </div>
  `,
  styles: [
    `
      :host ::ng-deep .mat-mdc-form-field-infix {
        width: auto;
      }

      .formly-form-flex {
        flex: 1 1 0;
        display: flex;
        gap: 20px;
      }
    `,
  ],
})
export class FlexLayoutColComponent extends FieldType {}
